import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.6.2_@types+node@20.4.0_eslint@8.44.0_typescript@5.1.6_vue-tsc@1.8.4/node_modules/nuxt/dist/pages/runtime/validate.js";
import debug_45global from "/vercel/path0/frontend/tixx-auth-frontend/middleware/debug.global.ts";
export const globalMiddleware = [
  validate,
  debug_45global
]
export const namedMiddleware = {}